<template>
    <div>
         <!-- HEADER TITULO -->
        <!-- <div class="titulo-homefunc">
            <img src="@/assets/imagenes/banner_homefuncionarios.jpg" class="d-block w-100 h-100">            
        </div> -->
        <!-- CONTENIDO PRINCIPAL -->
        <div class="contenido_principal_funcionarios">
            
            <!-- Componente de las cards de funcionarios -->
            <!-- <cards-funcionarios></cards-funcionarios> -->
            
            <!-- Componente Sitos de interés del home de funcionarios -->
            <!-- <sitios-interes></sitios-interes> -->
            
            <!-- Componente Otros Enlaces tomado del home de ciudadanos -->
            <!-- <otros-enlaces></otros-enlaces> -->
        </div>

        <!-- ------------------------------- -->
        <!-- --- CONTENIDO CONSTRUCCION ---- -->
        <!-- ------------------------------- -->
        <pagina-construccion 
            nombreApartado="Funcionarios Públicos"
            enlace="http://www.haciendachiapas.gob.mx/">
        </pagina-construccion>
        

    </div>
</template>
<script>

import cardsFuncionarios from './cards-funcionarios.vue';
import sitiosInteres from './sitiosDeInteres.vue';
import otrosEnlaces from '../home/Otros-enlaces.vue';
import paginaConstruccion from './../Construccion'

export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        cardsFuncionarios,
        sitiosInteres,
        otrosEnlaces,
        paginaConstruccion,
    }
}
</script>
<style scoped>
    /* HEADER TITULO */
    .titulo-homefunc{
        width: auto;
        height: auto;
        background-color:#ad985f;
        /* background-image: url('../../assets/imagenes/banner_homefuncionarios.jpg'); */
        color: white;    
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center; 
        border-bottom: 10px solid #621132;
    }
    .titulo-homefunc .negrita{
        font-weight: 400;
    }
    .titulo-homefunc .normal{
        font-weight: 100;
    }
    /* CONTENIDO PRINCIPAL */
    .contenido_principal_funcionarios{
        height: 100%;
    }
    

    /* MEDIA QUERY PARA MOVILES*/
@media only screen and (max-device-width : 900px){
    /* HEADER TITULO */
    .titulo-homefunc{
        background-position-x: center;
        border-bottom: 7px solid #621132;
    }
}

</style>